import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "posthog-js";

/**
 * Component that tracks page views whenever the route changes
 * This component doesn't render anything visible - it just tracks analytics
 */
export const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    const currentPath = location.pathname;

    // Capture page view with additional context
    posthog.capture("$pageview", {
      $current_url: window.location.href,
      path: currentPath,
      search: location.search,
      title: document.title,
      referrer: document.referrer || undefined,
      screen_width: window.innerWidth,
      screen_height: window.innerHeight,
      timestamp: new Date().toISOString(),
    });
  }, [location]);

  // This component doesn't render anything
  return null;
};
